import './style.scss'
import React from 'react'
import DKV_CONFIGURATION from 'constants/dkv.constants'

/**
 * Display DKV user name color
 * @param {object} props
 * @param {string} props.name
 * @param {object} props.metadata
 * @param {string} props.metadata.codcliente
 */
function TextColorNotClient(props) {
  const { metadata = {}, name, className: _classname = '' } = props

  let className = _classname
  if (DKV_CONFIGURATION.isDKV && !metadata.codcliente) className += 'text_color_not_client'

  return (
    <span title={name} className={`text-ellipsis ${className ? className : ''}`}>
      {name}
    </span>
  )
}

export default TextColorNotClient